import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as GlobalModalActions from '../../redux/actions/GlobalModalActions';
import { ModalSize } from '../../utils/Constants';

const CleanModal = (props) => {
  const { isOpen, children, className, hideModal, size = 'medium', onClose } = props;
  const classes = classNames('custom-modal', 'fade', className, { show: isOpen });

  return (
    <div className={classes} role="dialog">
      <div className="modal-overlay" onClick={onClose || hideModal()} />
      <div className="custom-modal-content centered">
        <div className={`custom-modal-dialog ${size}`}>{children}</div>
      </div>
    </div>
  );
};

CleanModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(ModalSize),
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...GlobalModalActions,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CleanModal);
